<template>
  <v-container fluid id="topimage">
    <v-row class="menu_box">
      <v-col cols="12" sm="6" lg="6">
        <v-row class="text_center_box">
          <img src="img/top.jpg">
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" lg="6">
        <v-row class="text_center_box"
        >
          <div id="tittle_image">
            <img src="img/logo.png">
            <h3>Suzuka Hisamatsu Exhibition</h3>
            <v-btn outlined color="#999999" link to="/works">{{$t("home.worksbtn")}}</v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <div class="spacer-1 d-none d-sm-flex"></div>
    </v-row>
    <div class="section1">
    <v-row class="menu_box flex-row-reverse">
      <v-col cols="12" sm="6" lg="6">
        <v-row class="text_center_box">
          <img src="img/wolke.jpg">
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" lg="6">
        <v-row class="text_center_box"
        >
          <div>
            <h2>Video</h2>
            <p>{{$t("home.videoinfo")}}</p>
            <v-btn outlined color="#000000" link to="/video">{{$t("home.videobtn")}}</v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
    </div>
    <v-row>
      <div class="spacer-1 d-none d-sm-flex"></div>
    </v-row>
    <v-row class="menu_box">
      <v-col cols="12" sm="6" lg="6">
        <v-row class="text_center_box">
          <img src="img/suzuka5.JPG">
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" lg="6">
        <v-row class="text_center_box"
        >
          <div>
            <h2>Works</h2>
            <p>{{$t("home.worksinfo")}}</p>
            <v-btn outlined color="#000000" link to="/works">{{$t("home.worksbtn")}}</v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <div class="spacer-1 d-none d-sm-flex"></div>
    </v-row>
    <div class="section2 bottom">
    <v-row class="menu_box flex-row-reverse">
      <v-col cols="12" sm="6" lg="6">
        <v-row class="text_center_box">
          <img src="img/suzuka1.jpg">
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" lg="6">
        <v-row class="text_center_box"
        >
          <div>
            <h2>Information</h2>
            <p>{{$t("home.aboutinfo")}}</p>
            <v-btn outlined color="#000000" link to="/information">{{$t("home.aboutbtn")}}</v-btn>
            <div>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>
    </div>
    <div class="section3 bottom">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col class="contact_box" cols="12">
          <h2 style="margin-bottom:30px;text-align:center;">{{$t("home.contact")}}</h2>
          <p style="text-align:center;"><v-fa :icon="['fab', 'instagram']" /> Instagram / <a href="https://www.instagram.com/szka.11">szka.11</a></p>
          <p style="text-align:center;"><v-fa :icon="['far', 'envelope']" /> Mail / <a href="mailto:susukasan611@gmail.com">susukasan611@gmail.com</a></p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  title: 'Home',
  name: 'Home',
  data: () => ({
  }),
  created () {
    axios.get('img/wolke.jpg')
    axios.get('img/top.jpg')
    axios.get('img/suzuka5.JPG')
    axios.get('img/suzuka2.jpg')
  },
}
</script>

<style scoped>

.spacer-1 {
  height:250px;
}

#topimage {
  width:90%;
  max-width:1200px;
  margin-top:0px;
}

#tittle_image{
  width:70%;
}

.text_center_box {
  justify-content:left;
  align-content:center;
  align-items:center;
  height:100%;
}
img {
  width:100%;
}
.menu_box {
  margin:0px;
}

.text_center_box h3 {
  font-size:1.3rem;
  color:#999;
  font-weight:300;
  margin:15px 0;
}

.section1{
  margin: 80px calc(50% - 50vw);
  width: 100vw;
  padding: 100px calc(50vw - 50%) 100px calc(50vw - 50%);
  position: relative;
  z-index: 0;
}
.section2{
  margin: 80px calc(50% - 50vw) 30px;
  width: 100vw;
  padding: 100px calc(50vw - 50%) 100px calc(50vw - 50%);
  position: relative;
  z-index: 0;
}
.section3{
  margin: 80px calc(50% - 50vw) 30px;
  width: 100vw;
  padding: 100px calc(50vw - 50%) 100px calc(50vw - 50%);
  position: relative;
  z-index: 0;
}

.section1::after{
  content: '';
  position: absolute;
  left:0;
  top: 0;

  /*四角形を傾けます*/
  transform: skewY(5deg);
  transform-origin: center center;

  z-index: -1;
  width:100%;
  height:100%;
  background:#fff676;
}
.section2::after{
  content: '';
  position: absolute;
  left:0;
  top: 0;

  /*四角形を傾けます*/
  transform: skewY(-5deg);
  transform-origin: center center;

  z-index: -1;
  width:100%;
  height:100%;
  background:#fff676;
}
.section2.bottom ::before{
  content: '';
  position: absolute;
  left:0;
  top: 300px;

  /*四角形を傾けます*/
  transform: skewY(-5deg);
  transform-origin: center center;

  z-index: -1;
  width:100%;
  height:100%;
  background:#fff676;
}

.section3::after{
  content: '';
  position: absolute;
  left:0;
  top: 0;

  /*四角形を傾けます*/
  transform: skewY(-5deg);
  transform-origin: center center;

  z-index: -1;
  width:100%;
  height:100%;
  background:#ffffff;
}
.section3.bottom ::before{
  content: '';
  position: absolute;
  left:0;
  top: 300px;

  /*四角形を傾けます*/
  transform: skewY(-5deg);
  transform-origin: center center;

  z-index: -1;
  width:100%;
  height:100%;
  background:#ffffff;
}

@media (min-width: 600px) {
  #topimage {
    margin-top:20px;
  }
  .text_center_box {
    justify-content:center;
    align-content:center;
    align-items:center;
    height:100%;
  }
  .contact_box {
    justify-content:left;
    align-content:center;
    align-items:center;
    height:100%;
  }
  img {
    width:100%;
  }
  .menu_box {
    margin:20px 0px;
  }

  .section1{
    margin: 0 calc(50% - 50vw);
    padding: 150px calc(50vw - 50%) 150px calc(50vw - 50%);
  }
  .section2{
    margin: 0 calc(50% - 50vw);
    padding: 150px calc(50vw - 50%) 150px calc(50vw - 50%);
  }

}

</style>
